import styled from 'styled-components';

import InitialsIcon from './InitialsIcon';

export default styled(InitialsIcon)`
  text-transform: uppercase;
  color: var(--white);
  width: 2rem;
  height: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2rem;
  font-size: 0.8rem;
`;
